export const RootSelector = {
  ROOT: ':root'
};
